module.exports = __webpack_public_path__ + "img/home-yellow.19e6b046.png";